import { isAxiosError } from 'axios'

export const INSUFFICIENT_BALANCE_DETAIL = 'Недостаточно средств на балансе'
export const INSUFFICIENT_BALANCE_ERROR_CODE = 'INSUFFICIENT_TOKENS'
export const INSUFFICIENT_BALANCE_MODAL_ID = 'insufficient-balance-modal'
const INSUFFICIENT_BALANCE_OPEN_EVENT = 'insufficient-balance:open'

export type InsufficientBalanceStep = 1 | 2
export type InsufficientBalanceOpenDetail = {
    step?: InsufficientBalanceStep
}

export const openInsufficientBalanceModal = (detail?: InsufficientBalanceOpenDetail) => {
    if (typeof document === 'undefined') return

    const modals = document.querySelectorAll('.modal-toggle') as NodeListOf<HTMLInputElement>
    modals.forEach(modal => {
        if (modal.id === INSUFFICIENT_BALANCE_MODAL_ID) return
        modal.checked = false
    })

    document.dispatchEvent(new CustomEvent<InsufficientBalanceOpenDetail>(INSUFFICIENT_BALANCE_OPEN_EVENT, { detail }))
}

export const listenInsufficientBalanceModalOpen = (handler: (detail: InsufficientBalanceOpenDetail) => void) => {
    if (typeof document === 'undefined') return () => undefined

    const listener = (event: Event) => {
        const customEvent = event as CustomEvent<InsufficientBalanceOpenDetail>
        handler(customEvent.detail || {})
    }

    document.addEventListener(INSUFFICIENT_BALANCE_OPEN_EVENT, listener)
    return () => {
        document.removeEventListener(INSUFFICIENT_BALANCE_OPEN_EVENT, listener)
    }
}

export const closeInsufficientBalanceModal = () => {
    if (typeof document === 'undefined') return

    const checkbox = document.getElementById(INSUFFICIENT_BALANCE_MODAL_ID) as HTMLInputElement | null
    if (!checkbox) return

    checkbox.checked = false
}

export const isInsufficientBalanceError = (error: unknown) => {
    if (!isAxiosError<{ detail?: string; error_code?: string }>(error)) return false

    const detail = error.response?.data?.detail
    const errorCode = error.response?.data?.error_code

    return detail === INSUFFICIENT_BALANCE_DETAIL || errorCode === INSUFFICIENT_BALANCE_ERROR_CODE
}
